import React from 'react';
import { Empty } from 'antd';
import { useSelector } from 'react-redux';

import { MessagesMasksSelectors } from 'common/config/store';
import StyledTable from 'components/organisms/styled-table';
import { useIntl } from 'common/config/i18n';

import { Props, useColumns } from './use-table-columns';

const ConstitutionTable: React.FC<Props> = ({ onClickEdit, isAdmin }) => {
  const { t } = useIntl();

  const data = useSelector(MessagesMasksSelectors.messagesMasksSelector);

  const columns = useColumns({ isAdmin, onClickEdit });

  return (
    <StyledTable
      rowKey="id"
      dataSource={data}
      columns={isAdmin ? columns : columns.filter((column) => !column.shouldBeAdmin)}
      locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t('empty')} /> }}
      pagination={false}
    />
  );
};

export default ConstitutionTable;
